const ImportFromExcelEnum = {
  PASS: 1,
  ERROR: 2,
  EXISTS: 3
}
export default ImportFromExcelEnum


// WEBPACK FOOTER //
// ./src/enum/importFromExcelEnum.js